export const FILTERS_PATH_NEW = '/filters/new';
export const FILTERS_PATH_EDIT = '/filters/:id/edit';
